export enum WorkloadItemStatus {
    OPEN,
    STARTED,
    QUOTED
}

